import { o_global } from "../../common/namespaces";
import { assignNamespace } from "../../common/namespace-utils";
import { defineStore } from "../nexus/defines.js";
import { Hybrid, hybrid } from "./body/hybrid";
import { Orientation, orientation } from "./body/orientation";
import { isTouchable } from "./body/touch";
import * as screen from "./body/screen.js";
import { os, OsType } from "./body/os";
import { Browser, browser } from "./body/browser";
import { DeviceType, type } from "./body/type";
import type { DevicePointerType, DeviceScreenSpecs } from ".";

export * from "./body/browser";
export * from "./body/events";
export * from "./body/hybrid";
export * from "./body/orientation";
export * from "./body/os";
export * as screen from "./body/screen";
export * from "./body/touch";
export * from "./body/type";

/**
 *
 */
export type GlobalDevice = {
  os: `${OsType}`;
  browser: `${Browser}`;
  /*                                */
  orientation: Orientation;
  /*                                */
  hybrid: Hybrid;
  type: `${DeviceType}`;
};

/**
 *
 */
export const device = assignNamespace(
  o_global,
  "device",
  {
    os: os(),
    browser: browser(),
    orientation: orientation(),
    hybrid: undefined as unknown as Hybrid,
    type: type(),
  },
  {
    Hybrid,
    Orientation,
    isTouchable: isTouchable(),
    screen,
    breakpoint: o_global.breakpoint,
  },
);
/*                                          */
device.hybrid = hybrid();

/**
 *
 *
 *
 *
 */
export const getPointerType = (): DevicePointerType =>
  otto.device.pointerType.get() ?? { isTouchable: false, isHybrid: false };

/**
 *
 *
 *
 *
 */
export const getScreenSpecs = (): DeviceScreenSpecs => ({
  width: screen.getWidth(),
  height: screen.getHeight(),
  pixelRatio: screen.getDevicePixelRatio(),
});

otto.device.assignNamespace({
  pointerType: defineStore<DevicePointerType | undefined>({
    isTouchable: isTouchable(),
    isHybrid: device.hybrid.isHybrid,
  }),
  getPointerType,
  getScreenSpecs,
});
